import * as actions from './action';

export const initialState = {
    tags: {},
};

export const reducer = (state, action) => {
    switch(action.type) {
        case actions.tagChange: {
            return {
                ...state,
                tags: action.payload,
            }
        }
        default:
            return state;
    }
};